import _ from 'lodash';
import {
  compMethodOptions,
  contributionTypeOptions,
  deathBenefitOptions,
  formattedValue,
  rateBasisOptions,
} from 'src/constants/coverage';

import UniTobaccoRates from 'src/files/life/uni-tobacco-rates-example.xlsx';
import TobaccoRates from 'src/files/life/tobacco-rates-example.xlsx';

export const useLifeIssuerBuild = () => {
  const build = {
    coverage: 'life',
    title: 'Life',
    form_options: {
      import_data: [
        {
          title: 'Uni-tobacco Age Rates',
          file: UniTobaccoRates,
          file_name: 'uni-tobacco-rates-example',
          key: 'uni_tobacco',
        },
        {
          title: 'Tobacco/Non-Tobacco Age Rates',
          file: TobaccoRates,
          file_name: 'tobacco-rates-example',
          key: 'tobacco',
        },
      ],
    },
    card_options: {
      plan: [
        {
          title: 'Contribution',
          key: 'contribution',
          format: () => 'Employer',
        },
        {
          title: 'Death Benefit',
          key: 'death_benefit',
          format: (value) => formattedValue(value),
        },
      ],
    },
    offer_details: [
      {
        key: 'contribution_type',
        options: { render_type: 'select', render_data: contributionTypeOptions },
      },
      {
        key: 'death_benefit',
        format: (value) => {
          return _.isNumber(Number(value)) && !isNaN(Number(value)) ? formattedValue(value) : value;
        },
        options: { render_type: 'select', render_data: deathBenefitOptions, type: 'other' },
      },
      {
        key: 'rate_per_unit',
        format: (value) => formattedValue(value),
        options: { render_type: 'input', inputType: 'number', symbol: '$', minValue: 0 },
      },
      { key: 'rate_basis', options: { render_type: 'select', render_data: rateBasisOptions } },
      {
        key: 'comp_method',
        options: { render_type: 'select', render_data: compMethodOptions },
      },
    ],
  };

  return { build };
};
